import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import Logo from "@/components/Logo";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Fleet", href: "#fleet" },
  { label: "Contact", href: "#contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled
          ? "border-b border-white/10 bg-ink/85 backdrop-blur-xl"
          : "border-b border-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <a href="#top" data-testid="nav-logo-link" className="flex items-center gap-3">
          <Logo size={38} />
          <span className="font-display text-xl font-bold uppercase leading-none tracking-wide">
            Zaki <span className="text-cobalt">Logistics</span>
            <span className="mt-1 block font-mono text-[10px] font-normal tracking-[0.3em] text-white/50">
              OMAHA · NE
            </span>
          </span>
        </a>

        <div className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}-link`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-white/70 transition-colors hover:text-white"
            >
              {l.label}
            </a>
          ))}
        </div>

        <a
          href="tel:+14026391139"
          data-testid="nav-call-button"
          className="flex items-center gap-2 rounded-full bg-cobalt px-5 py-2.5 text-sm font-semibold transition-colors duration-300 hover:bg-white hover:text-ink"
        >
          <Phone className="h-4 w-4" />
          <span className="hidden sm:inline">402-639-1139</span>
          <span className="sm:hidden">Call</span>
        </a>
      </nav>
    </header>
  );
}
